'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var AgentSalesSummaryChart = new Class({
    Implements: [Events, Options],
    options: {},
    initialize: function initialize(element, options) {
        this.setOptions(options);
        this._element = element;

        this.chartData = null;
        if (this._element) {
            this.fetchChartData();
        }
    },
    fetchChartData: function fetchChartData() {
        var self = this;
        var rpcUrl = this._element.getAttribute('data-rpc');

        new Remote({
            rpc: rpcUrl,
            onSuccess: function onSuccess(response) {
                var data = this.get_data();
                self.chartData = data;

                // Calculate display conditions
                var years = self.chartData ? Object.keys(self.chartData) : [];
                var totalSales = years.reduce(function (sum, year) {
                    return sum + (self.chartData[year].sales || 0);
                }, 0);
                var minYears = 4;
                var minTransactions = 30;

                // Hide chart if: no data, less than 4 years, or less than 30 transactions
                if (!self.chartData || years.length < minYears || totalSales < minTransactions) {
                    var summary = document.getElementById('agent_sales_summary');
                    if (summary) {
                        summary.style.display = 'none';
                        // Clear any temporary height constraint
                        summary.style.minHeight = '';
                    }

                    var comps = document.getElementById('sales-history-comps');
                    if (comps) {
                        var noAgentSales = comps.querySelector('.no-agent-sales');
                        if (noAgentSales) {
                            noAgentSales.style.display = 'flex';
                        } else if (comps.parentElement) {
                            comps.parentElement.remove();
                        }
                    }
                } else {
                    // Hide the no-data message if it exists
                    var _comps = document.getElementById('sales-history-comps');
                    if (_comps) {
                        var _noAgentSales = _comps.querySelector('.no-agent-sales');
                        if (_noAgentSales) {
                            _noAgentSales.style.display = 'none';
                        }
                    }

                    // Show the chart container
                    var _summary = document.getElementById('agent_sales_summary');
                    if (_summary) _summary.style.display = 'block';

                    self.createChart();
                }
            },
            onError: function onError() {
                console.error('Failed to fetch chart data from RPC URL');
            }
        });
    },

    createChart: function createChart() {
        var self = this;
        var years = Object.keys(this.chartData);
        var sales = years.map(function (year) {
            var data = self.chartData[year];

            var price_range = 'N/A';
            if (data.from != null && data.to != null) {
                data.from = Number(data.from);
                data.to = Number(data.to);
                price_range = '$' + data.from.toLocaleString('en-US') + ' \u2013 $' + data.to.toLocaleString('en-US');
            } else if (data.from != null) {
                data.from = Number(data.from);
                price_range = '$' + data.from.toLocaleString('en-US') + ' and up';
            } else if (data.to != null) {
                data.to = Number(data.to);
                price_range = 'Up to $' + data.to.toLocaleString('en-US');
            }

            return {
                y: data.sales,
                price_range: price_range,
                year: year
            };
        });

        var maxSales = Math.max.apply(Math, _toConsumableArray(sales.map(function (item) {
            return item.y;
        })));
        var volume = years.map(function (year) {
            var data = self.chartData[year];
            return {
                y: data.volume,
                year: year
            };
        });

        // Clear any temporary height constraint
        this._element.style.minHeight = '';

        this.chart = Highcharts.chart(this._element, {
            chart: {
                type: 'column',
                backgroundColor: 'transparent',
                plotBackgroundColor: 'transparent',
                style: {
                    overflow: 'visible'
                }
            },
            title: null,
            xAxis: {
                categories: years,
                labels: {
                    style: {
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: 'normal'
                    }
                },
                lineColor: '#555',
                tickColor: '#555',
                gridLineWidth: 0, // turn off default vertical lines
                plotLines: [{
                    color: '#555',
                    width: 1,
                    value: -0.5 // left border
                }, {
                    color: '#000',
                    width: 1,
                    value: years.length - 0.5 // right border
                }]
            },
            yAxis: [{
                title: {
                    text: 'Sales Volume',
                    align: 'high',
                    style: {
                        color: '#5A8EC4',
                        fontSize: '14px',
                        fontWeight: 'bold'
                    }
                },
                labels: {
                    style: {
                        color: '#5A8EC4',
                        fontSize: '14px',
                        fontWeight: 'bold'
                    },
                    x: -10,
                    formatter: function formatter() {
                        var val = this.value;
                        if (val >= 1000000) {
                            var num = (val / 1000000).toFixed(1);
                            return '$' + (num.endsWith('.0') ? num.slice(0, -2) : num) + 'M';
                        } else if (val >= 1000) {
                            var _num = (val / 1000).toFixed(1);
                            return '$' + (_num.endsWith('.0') ? _num.slice(0, -2) : _num) + 'K';
                        }
                        return '$' + val;
                    }
                },
                gridLineWidth: 0
            }, {
                title: {
                    text: 'Sales',
                    align: 'high',
                    style: {
                        color: '#B14963',
                        fontSize: '14px',
                        fontWeight: 'bold'
                    }
                },
                labels: {
                    style: { color: '#B14963', fontSize: '14px', fontWeight: 'bold' }, x: 10,
                    formatter: function formatter() {
                        return Math.round(this.value);
                    }
                },
                allowDecimals: false,
                tickInterval: Math.ceil(maxSales / 5) || 1,
                gridLineWidth: 0,
                opposite: true
            }],
            legend: {
                enabled: false // hides the bottom legend
            },
            credits: {
                enabled: false
            },
            series: [{
                name: 'Volume',
                data: volume,
                color: '#7FB0E7',
                states: {
                    hover: {
                        color: '#5A8EC4'
                    }
                }
            }, {
                name: 'Sales',
                data: sales,
                yAxis: 1,
                type: 'spline',
                color: '#B14963'
            }],
            tooltip: {
                useHTML: true,
                backgroundColor: 'none',
                borderWidth: 0,
                shadow: false,
                style: {
                    padding: 0
                },
                shared: true,
                formatter: function formatter() {
                    if (Math.round(this.points[0].y) === 0) {
                        return '';
                    }

                    var s = '<div style="border:2px solid #707070;padding:10px;background:#fff;width:310px;border-radius:10px;">';
                    s += '<div style="font-size:12px;line-height:1.6;font-weight:700;color:#aaa;margin-bottom:5px;">' + this.points[0].point.year + '</div>';
                    s += '<div style="display:flex;gap:10px;">';

                    s += '<div style="background:#f2f2f2;border-radius:10px;padding:10px;flex:1;">';
                    s += '<b style="font-size:16px;display:block;color:#5A8EC4;">$' + Math.round(this.points[0].y).toLocaleString('en-US') + '</b>';
                    s += '<span style="font-size:10px;line-height:1.6;">Sales Volume for the Year</span>';
                    s += '</div>';

                    if (this.points[1] && this.points[1].y !== null && this.points[1].y !== undefined) {
                        s += '<div style="background:#f2f2f2;border-radius:10px;padding:10px;">';
                        s += '<b style="font-size:16px;display:block;color:#B14963;">' + Math.round(this.points[1].y).toLocaleString('en-US') + '</b>';
                        s += '<span style="font-size:10px;line-height:1.6;">Total Sales</span>';
                        if (this.points[1].point.options.price_range) {
                            s += '<div style="font-size:10px;line-height:1.6;color:#333;">' + this.points[1].point.options.price_range + '</div>';
                        }
                        s += '</div>';
                    }

                    s += '</div>';
                    s += '</div>';
                    return s;
                }
            },
            plotOptions: {
                column: {
                    pointPadding: 0.02, // spacing between columns (default is 0.1)
                    groupPadding: 0.04 // spacing between groups of columns (default is 0.2)
                },
                series: {
                    states: {
                        inactive: {
                            opacity: 1 // disables dimming other series on hover
                        }
                    }
                }
            },
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 480 // or 600, depending on your breakpoints
                    },
                    chartOptions: {
                        yAxis: [{
                            title: {
                                style: {
                                    fontSize: '12px'
                                }
                            },
                            labels: {
                                style: {
                                    fontSize: '10px'
                                },
                                x: -5
                            }
                        }, {
                            title: {
                                style: {
                                    fontSize: '12px'
                                }
                            },
                            labels: {
                                style: {
                                    fontSize: '10px'
                                },
                                x: 5
                            }
                        }],
                        xAxis: {
                            labels: {
                                style: {
                                    fontSize: '10px'
                                }
                            }
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0,
                                groupPadding: 0.01
                            }
                        }
                    }
                }]
            }

        });
    },

    updateChart: function updateChart(newRpcUrl) {
        // Update the RPC URL and refetch data
        this._element.setAttribute('data-rpc', newRpcUrl);

        // Store current height to prevent jumping
        var currentHeight = this._element.offsetHeight;
        if (currentHeight > 0) {
            this._element.style.minHeight = currentHeight + 'px';
        }

        // Destroy existing chart if it exists
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }

        // Clear the element content and refetch data
        this._element.innerHTML = '';
        this.fetchChartData();
    }

});
'use strict';

var Schools = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_schools',
		customId: 'schools'
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) this.build();
	},

	build: function build() {
		var self = this;
		var rpc = this._element.get('data-rpc');

		if (rpc) {
			var remote = new Request.HTML({
				url: rpc,
				onSuccess: function onSuccess(a, b, c, d) {
					if (c === "") {
						self._element.getParent().dispose();
						return;
					}

					this.data = c;
					self._element.set('html', this.data);

					new Tabscroll(self.options.customId);

					var _shrinkers = self._element.getElements('.w_shrinker');

					_shrinkers.each(function (_shrinker) {
						var min_height = 270;

						new Shrinker(_shrinker, {
							min_height: min_height,
							toggler: _shrinker.getParent('.w_tabscroll_item').getElement('.w_shrinker_head'),
							single_opened: false,

							onShrink: function onShrink() {
								this._toggler.removeClass('_opened');
								this._toggler.set('html', '<span class="w_shrinker_button">Show more</span>');
							},

							onUnshrink: function onUnshrink() {
								this._toggler.addClass('_opened');
								this._toggler.set('html', '<span class="w_shrinker_button">Show less</span>');
							}
						});
					});
				},

				onFailure: function onFailure() {
					self._element.getParent().dispose();
				}
			});

			remote.get();
		}
	}
});
'use strict';

var Tabscroll = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'w_tabscroll'
	},

	initialize: function initialize(_element, options) {
		this._element = document.id(_element);

		if (this._element) {
			this.setOptions(options);
			this.build();
		}
	},

	build: function build() {
		var fcls = '.' + this.options.cls;
		var _element = document.id(this);

		this._tabs = _element.getElements(fcls + '_tabs li');
		this._content = _element.getElement(fcls + '_content');
		this._strip = _element.getElement(fcls + '_strip');
		this._items = _element.getElements(fcls + '_item');
		this.fx_items = [];

		this.active_index = 0;

		if (!this._items || this._items.length == 0) {
			this._element.dispose();
			return;
		}

		this.fx_scroll = new Fx.Scroll(this._content, {
			duration: 500,
			link: 'cancel'
		});

		this._tabs.each(function (_el, i) {
			_el.addEvent('click', this.select.bind(this, _el, i));

			if (this._tabs.length == 1) {
				_el.addClass('_full_width');
			} else if (i == 0) {
				_el.addClass('_first');
			} else if (i == this._items.length - 1) {
				_el.addClass('_last');
			}

			this.fx_items.push(new Fx.Morph(this._items[i], {
				duration: 1000,
				link: 'cancel'
			}));

			if (_el.hasClass('active') && i > 0 && this._items.length > 1) {
				this.select(_el, i);
			}
		}.bind(this));
	},

	select: function select(_tab, i, e) {
		if (e && e.stop) e.stop();

		if (this.active_index == i) return;

		this._tabs[this.active_index].removeClass('active');
		this.active_index = i;

		this._tabs[i].addClass('active');
		this.fx_scroll.toElement(this._items[i]);

		this.fx_items[i].start({
			opacity: [0, 1]
		});

		this.fireEvent('tabchange', i);
	},

	toElement: function toElement() {
		return this._element;
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var ColumnChart = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_columnchart',
		max_value: 0,
		increment: 100, //increment of the scale
		height: 500, //it's not a total height of the chart, it's height of it's scale
		disp_col: 5, //amount of displayed columns
		scroll_speed: 300,
		animate_values: true,
		scroll_at_a_time: 3, //how many items scroll at a time
		y_axis: '', //displayed name of y axis
		hscroll: true,
		zebra: true, //zebra background
		has_images: true,
		main_item_indicator: false, //horisontal dashed line
		scale_px_increment: 30,
		data: null,
		isBuilding: false,
		missingImage: null
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls);
		this._element.addClass('_loading');

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var opts = this.options;

		if (Core.is_ie8()) {
			this._element.addClass('ie');
		}

		this.max_value = opts.max_value;

		if (opts.y_axis != '') {
			this._y_axis = new Element('.y_axis', { 'html': '<div class="vertical_text">' + opts.y_axis + '</div>' }).inject(this._element);
		}

		this._chart = new Element('.chart').inject(this._element);

		if (opts.zebra) {
			this._zebra = new Element('.zebra').inject(this._chart);
		}

		this._scroller = new Element('.scroller').inject(this._chart);

		this._col_container = new Element('.col_container').inject(this._scroller);

		this.property = this._element.getProperty('data-property');
		this.y_axis_text = this._element.getProperty('data-yaxis-name');

		if (opts.data) {
			this.data = opts.data;
			this.process_rpc();
		} else {
			this.rpc_request();
		}

		this.add_functionalities();
	},

	add_hscroll: function add_hscroll() {
		var self = this;
		var opts = this.options;
		var _hscroll = this._hscroll = new Element('.hscroller', { 'html': '<div class="ar_l">&nbsp;</div><div class="dragger">|||</div><div class="ar_r">&nbsp;</div>' });
		_hscroll.inject(this._chart);

		this._element.addClass('_has_dragger');

		var _ar_l = this._ar_l = _hscroll.getElement('.ar_l');
		var _ar_r = this._ar_r = _hscroll.getElement('.ar_r');

		_ar_l.addEvent('click', function () {
			self._arr_prev.fireEvent('click');
		});

		_ar_r.addEvent('click', function () {
			self._arr_next.fireEvent('click');
		});

		var _dragger = this._dragger = _hscroll.getElement('.dragger'),
		    size_coefficient = this._items.length - opts.disp_col;

		this.dragger_fx = new Fx.Morph(_dragger, {
			link: 'cancel',
			duration: 1000,
			transition: Fx.Transitions.linear
		});

		if (size_coefficient > 20) {
			size_coefficient = 20;
		} else if (size_coefficient < 2) {
			size_coefficient = 2;
		}

		var dr_size = _hscroll.getSize().x / size_coefficient;

		_dragger.setStyle('width', dr_size);

		var max_left = self.dragger_max_left = _hscroll.getSize().x - dr_size,
		    dragger_left = max_left / (this._items.length - opts.disp_col) * this.current_col;

		if (this.current_col == 0) {
			_ar_l.addClass('inactive');
		} else if (this.current_col == this.last) {
			_ar_r.addClass('inactive');
		}

		(function () {
			self.dragger_fx.start({ 'left': dragger_left });
			self.dragger_fx.setOptions({ duration: self.options.scroll_speed });
		}).bind(this).delay(2000);

		_hscroll.addEvents({
			'mouseenter': function mouseenter() {
				if (self.dragging != true) self._element.addClass('dragging');
			},
			'mouseleave': function mouseleave() {
				if (self.dragging != true) self._element.removeClass('dragging');
			}
		});

		_dragger.addEvent('mousedown', function (e) {
			self.dragging = true;
			self._element.addClass('dragging');
			dragger_left = _dragger.getStyle('left').toInt();
			self.init_pos = e.page.x;
			return false;
		});

		$(document.body).addEvents({
			'mousemove': function mousemove(e) {
				if (self.dragging) {
					var hmove = e.page.x - self.init_pos,
					    left = dragger_left + hmove;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);

					var area = self.drag_area = (left / (max_left / (self._items.length - opts.disp_col))).round();

					self.animate.set(left * ((self._col_container.getSize().x - self.scr_width) / max_left), 0);

					if (self.current_col != area) {
						self.current_col = area;

						if (area == 0) {
							self._arr_prev.addClass('inactive');
							_ar_l.addClass('inactive');
						} else {
							self._arr_prev.removeClass('inactive');
							_ar_l.removeClass('inactive');
						}

						if (area == self._items.length - opts.disp_col) {
							self._arr_next.addClass('inactive');
							_ar_r.addClass('inactive');
						} else {
							self._arr_next.removeClass('inactive');
							_ar_r.removeClass('inactive');
						}
					}

					self.hide_locked_item();
				}
			},

			'mouseleave': function mouseleave() {
				self.dragging = false;
				self._element.removeClass('dragging');
			},

			'mouseup': function mouseup() {
				self.dragging = false;
				self._element.removeClass('dragging');
			}
		});
	},

	// Get a nice rounded interval for the scale
	getNiceInterval: function getNiceInterval(rawInterval) {
		var niceIntervals = [100, 250, 500, 1000, 2500, 5000, // for ppsqft values
		10000, 25000, 50000, 100000, 250000, 500000, 1000000, 2000000, 5000000, 10000000, 20000000, 50000000, 100000000];
		for (var i = 0; i < niceIntervals.length; i++) {
			if (niceIntervals[i] >= rawInterval) {
				return niceIntervals[i];
			}
		}
		return niceIntervals[niceIntervals.length - 1];
	},

	create_scale: function create_scale() {
		this._scale = new Element('.scale');

		if (this._y_axis) {
			this._scale.inject(this._y_axis, 'after');
		} else {
			this._scale.inject(this._element, 'top');
		}

		// Calculate the number of increments that can fit into the chart height
		var numIncrements = Math.floor(this.options.height / this.options.scale_px_increment);
		var rawIncrement = Math.ceil(this.max_value / numIncrements);
		var increment = this.getNiceInterval(rawIncrement);

		// Recalculate max_value to be a multiple of the nice increment
		this.max_value = Math.ceil(this.max_value / increment) * increment;

		// Recalculate number of increments based on nice interval
		numIncrements = Math.round(this.max_value / increment);

		var value = 0,
		    _el;

		this._values = [];

		// Adjust grid height based on the new increment value
		var grid_height = this.options.height / numIncrements;

		while (value <= this.max_value) {
			var grid_char = this.options.zebra ? '&bull;' : '-';
			var formattedValue = '$' + Core.short_number(value, 1);
			_el = new Element('.value', {
				'html': formattedValue + '<div class="grid">' + grid_char + '</div>',
				'styles': {
					'height': grid_height + 'px'
				}
			}).inject(this._scale, 'top');
			value += increment;

			this._values.push(_el);
		}

		// Set the topmost label (max value) height to 0 so it doesn't add extra space
		this._values[this._values.length - 1].setStyle('height', 0);

		this.options.height = grid_height * numIncrements;

		if (this._zebra) {
			var cls = '';
			this._values.each(function (_el, i) {
				var zebra_height = grid_height;

				if (cls == '') {
					cls = 'x';
					zebra_height -= 2; //dashed border of the zebra
				} else {
					cls = '';
				}

				var _strip = new Element('div', { 'class': cls });
				_strip.inject(this._zebra);
				_strip.setStyle('height', zebra_height);
			}.bind(this));

			var margin = this._scale.getElement('.grid').getCoordinates().top - this._chart.getCoordinates().top - this._scale.getElement('.grid').getStyle('margin-top').toInt();
			this._zebra.getElement('div').setStyle('margin-top', margin);
		} else {
			this._values.each(function (_el) {
				_el.setStyle('height', grid_height);
			});
		}

		var scale_height = this._scale.getSize().y - this._scale.getStyle('padding-top').toInt() + this._scale.getElement('.grid').getStyle('top').toInt();
		this._scale.setStyle('height', scale_height);

		var grid_width = this._chart.getComputedSize().computedBottom;
		this._scroller.setStyle('height', this._scale.getSize().y - grid_width);

		if (this._y_axis) {
			this._y_axis.setStyle('height', this._scale.getSize().y - grid_width);
		}

		this.set_prices();
	},

	set_prices: function set_prices() {
		var height;
		var price;

		this._items.each(function (e) {
			price = e.getAttribute('data-price').toInt();
			height = (price * this.options.height / this.max_value).round() - 1;

			if (this.options.animate_values == true) {
				e.setAttribute('data-height', height);
			} else {
				e.setStyle('height', height);
			}

			if (e.hasClass('main') && this._indicator) {
				this._indicator.setStyle('bottom', height).addClass('visible');
			}
		}.bind(this));
	},

	rpc_request: function rpc_request() {
		var self = this;

		if (!self.options.data) {
			new Remote({
				rpc: this._element.getAttribute('data-rpc'),
				method: 'get',
				onSuccess: function onSuccess() {
					self.data = this.get_data();
					self.process_rpc();

					document.fireEvent('columnChartLoaded');
				},
				onError: function onError() {
					this._element.set('html', 'Server connection error. Please try later');
				}
			});
		} else {
			self.process_rpc();
		}
	},

	process_rpc: function process_rpc() {
		this._items = [];
		var col_container_width = 0;

		if (this.data && this.data != '') {
			if (this.data.length < 2) {
				var parentComponent = this._element.closest('listing-pricing-comparison');
				if (parentComponent) {
					parentComponent.style.display = 'none';
				}
				this._element.removeClass('_loading');
				return;
			}

			this.change_y_label();

			var notFoundImageUrls = ['/l/not-found-grey-gallery-1.png', '/l/not-found-grey-gallery-2.png', '/l/not-found-grey-gallery-3.png', '/l/not-found-grey-gallery-4.png', '/l/not-found-grey-gallery-5.png', '/l/not-found-grey-gallery-6.png', '/l/not-found-grey-gallery-7.png', '/l/not-found-grey-gallery-8.png'];
			var notFoundImageCnt = 0;

			this.data.each(function (e, i) {

				if (!e.thumbor_images || !!e.thumbor_images && e.thumbor_images.length == 0) {
					var _index = notFoundImageCnt % 8;
					e.notFoundImageUrl = Res_i + notFoundImageUrls[_index];
					notFoundImageCnt++;
				}

				var price = e[this.property];

				price = price.toInt();

				if (this.max_value < price) {
					this.max_value = price;
				}

				var img_path,
				    name = (e.name || e.address || e.building_name || e.building_address) + (e.unit ? ', #' + e.unit : ''),
				    cls = 'bld_item' + (e.current == true ? ' main' : ''),
				    html = '';

				if (e.current == true && this.options.main_item_indicator) {
					this._indicator = new Element('.indicator', { 'html': '<div class="pointer">&nbsp;</div>' }).inject(this._chart).fade('hide');
				}

				if (this.options.has_images) {
					img_path = this.options.tmp_img || e.image;

					html = '<img src="' + img_path + '"' + 'onerror="' + this.options.err_img + '"' + '/>';
				}
				var vt_html = '<div class="vt_container">' + '<div class="vertical_text">' + name + '</div>' + '</div>';

				var add_cls = this._element.getAttribute('data-open') && this._element.getAttribute('data-open') == 'page' ? '' : ' w_blimp_bld';

				var _bld_item = new Element('div', {
					'class': cls + add_cls,
					'html': html,
					'data-price': e[this.property],
					'data-class': 'w_blimp_bld'
				});

				this._items.push(_bld_item);

				_bld_item.addEvents({
					'mouseenter': function () {
						// CITY-5606 QA: phones / tablets — no hover card (a listing tile that didn't
						// fit and opened the listing popup); a tap on the bar opens the listing page
						if (Core.prefer_pages_over_popups && Core.prefer_pages_over_popups()) return;
						if (this.locked_item) {
							this.locked_item.removeClass('_active');
						}

						this.locked_item = _bld_item;
						this.locked_item.addClass('_active');
						this.bulb_show(e, _bld_item);
					}.bind(this),
					'click': function click() {
						if (e.current == true) return;
						if (e.url_listing) {
							window.location = e.url_listing;
						} else if (e.building_url) {
							window.location = e.building_url;
						}
					}
				});

				// if(e.url_listing || e.url && e.url != ''){
				// 	_bld_item.set('data-rpc', e.url_listing || e.url);

				// 	if (this._element.getAttribute('data-open') && this._element.getAttribute('data-open') == 'page'){
				// 		_bld_item.addEvent('click', function(){ window.location = e.url_listing || e.url; });
				// 	}else{
				// 		new BlimpExt(_bld_item, {
				// 			draggable: true,
				// 			show_veil: true,
				// 			onPostRpc: function(){
				// 				new BldBlimp(this);
				// 			}
				// 		});
				// 	}
				// }

				var _column = new Element('div', {
					'class': 'column' + (i == this.data.length - 1 ? ' last' : ''),
					'html': vt_html
				}).adopt(_bld_item).inject(this._col_container);

				var col_w = _column.getComputedSize().width,
				    col_m = _column.getStyle('margin-right').toInt();

				col_container_width += col_w + col_m;

				if (!this.scroll_w_is_set) {
					this.set_scroll_width(col_w, col_m);
					this.scroll_w_is_set = true;
				}
			}.bind(this));

			(function () {
				this._col_container.setStyle('width', col_container_width);
			}).delay(500, this);

			this._main_col = this._scroller.getElement('.main');

			if (this._main_col) {
				this._init_scroll = this._main_col.getParent('.column');
			} else {
				//this.fireEvent('notEnoughData');
			}

			this.create_scale();

			if (this._scroller.getStyle('width').toInt() < col_container_width) {
				this.add_scrolling();
			}

			if (this.options.animate_values == true) {
				this.animate_prices();
			} else {
				if (this._indicator && this._indicator.hasClass('visible')) {
					this._indicator.fade('show');
				}
			}

			this._bulb = new Element('.' + this.options.cls + '_bulb', {
				'html': '<div class="pointer">&nbsp;</div>'
			}).inject(this._element);

			this._bulb.addClass('clearfix');

			if (!this.options.isBuilding) {
				this._bulb.addClass('_listings');
			} else {
				this._bulb.addClass('_buildings');
				this._bulb_content = new Element('div.bulb-content').inject(this._bulb, 'top');
				this._bulb_image = new Element('img.bulb-image').inject(this._bulb_content);
				this._info = new Element('div.info').inject(this._bulb_content);

				var content = this._info;
				this._bulb_name = new Element('a.name').inject(content);
				this._bulb_address = new Element('a.address').inject(content);
				this._bulb_details = new Element('span.details').inject(content);
				this._bulb_available_for_sale = new Element('a.apts_for_sale').inject(content);
				this._bulb_available_for_rent = new Element('a.apts_for_rent').inject(content);
				this._bulb_size = new Element('span.size').inject(content);
				this._bulb_created = new Element('span.created').inject(content);
				this._bulb_updated = new Element('span.updated').inject(content);
				// Grey box outside bulb-content for full width
				var grey_box = new Element('div.grey-box').inject(this._bulb_content, 'after');
				this._bulb_price = new Element('span.price').inject(grey_box);
				this._bulb_sales = new Element('span.sales').inject(grey_box);
			}

			this._chart.setStyle('visibility', 'visible');

			if (this._y_axis) {
				this._y_axis.setStyle('visibility', 'visible');
			}
		} else {
			this.fireEvent('noData');
		}

		this._element.removeClass('_loading');
	},

	change_y_label: function change_y_label() {
		if (!this._y_axis) return;

		this._y_axis.getElement('.vertical_text').set('html', this.y_axis_text);
	},

	set_scroll_width: function set_scroll_width(w, m) {
		var dc = this.options.disp_col;
		// Use chart container width if available, otherwise fallback to calculated
		var chartWidth = this._chart ? this._chart.getSize().x : 0;
		var width = this.scr_width = chartWidth > 0 ? chartWidth : w * dc + m * (dc - 1) - 100;

		this._scroller.setStyle('width', width);
	},

	bulb_show: function bulb_show(data, _el) {
		if (this._save_tooltip) {
			this._save_tooltip.hide();
		}
		if (this.bubble_is_ready && this.dragging != true) {
			if (!this.options.isBuilding) {
				this.add_listing_tile(data);
			} else {
				// Set building image (hide while loading to prevent stale image)
				var imgSrc = data.image || data.notFoundImageUrl;
				this._bulb_image.setStyle('opacity', '0');
				this._bulb_image.set('src', imgSrc);
				this._bulb_image.onload = function () {
					this.setStyle('opacity', '1');
				}.bind(this._bulb_image);

				var add_text = this.property == 'ppsqft' || this.property == 'sqft' ? ' /ft<sup>2</sup>' : '';
				var price = data[this.property];

				var transactions = data.transactions || 0;
				var str_sales = transactions > 1 ? 'sales' : 'sale';

				this._bulb_sales.set('html', 'Based on ' + transactions + ' ' + str_sales + '<br/>in past 12 months');

				if (data.sale && data.sale.available > 0) {
					var apts = data.sale.available > 1 ? ' Apartments' : ' Apartment';
					if (data.sale.min == data.sale.max) {
						this._bulb_available_for_sale.set('html', '<strong>' + data.sale.available + apts + ' for Sale</strong> for $' + Core.short_number(data.sale.min));
					} else {
						this._bulb_available_for_sale.set('html', '<strong>' + data.sale.available + apts + ' for Sale</strong> ($' + Core.short_number(data.sale.min) + ' - $' + Core.short_number(data.sale.max) + ')');
					}
					this._bulb_available_for_sale.removeEvents().addEvent('click', function (e) {
						e.stopPropagation();
						Cookie.write('crBovJumpTo', 'sale');
						window.location = data.building_url;
					});
				} else {
					this._bulb_available_for_sale.set('html', '');
				}

				if (data.rent && data.rent.available > 0) {
					var apts = data.rent.available > 1 ? ' Apartments' : ' Apartment';
					if (data.rent.min == data.rent.max) {
						this._bulb_available_for_rent.set('html', '<strong>' + data.rent.available + apts + ' for Rent</strong> for $' + Core.add_commas(data.rent.min));
					} else {
						this._bulb_available_for_rent.set('html', '<strong>' + data.rent.available + apts + ' for Rent</strong> ($' + Core.add_commas(data.rent.min) + ' - $' + Core.add_commas(data.rent.max) + ')');
					}
					this._bulb_available_for_rent.removeEvents().addEvent('click', function (e) {
						e.stopPropagation();
						Cookie.write('crBovJumpTo', 'rent');
						window.location = data.building_url;
					});
				} else {
					this._bulb_available_for_rent.set('html', '');
				}

				this._bulb_price.set('html', '$' + Core.add_commas(price) + add_text);
				this._bulb_name.set('text', (data.name || data.address || data.building_name || data.building_address) + (data.unit ? ', #' + data.unit : ''));
				this._bulb_name.set('href', data.url_listing || data.building_url);

				if (data.sqft) {
					this._bulb_size.set('html', 'Approx. ' + data.sqft + ' ft<sup>2</sup>');
				}
				// if (data.listing_added) {
				// 	this._bulb_created.set('text', 'Listed ' + data.listing_added);
				// }
				// if (data.listing_updated) {
				// 	this._bulb_updated.set('text', 'Updated ' + data.listing_updated);
				// }

				if (data.name || data.building_name) {
					if (data.address || data.building_address) {
						this._bulb_address.set('text', data.address || data.building_address);
					}
					if (data.url || data.building_url) {
						this._bulb_address.set('href', data.url_listing || data.building_url);
					}
					this._bulb_address.show();
				} else {
					this._bulb_address.hide();
				}

				// Commented out: interim pop-up on bulb click.
				// Building name now navigates directly to the building page.
				// if (this.options.isBuilding) {
				// 	this._bulb.set('data-class', 'w_blimp_bld');
				// 	this._bulb.set('href', data.url);
				//
				// 	new BlimpExt(this._bulb,	{
				// 		draggable: true,
				// 		show_veil: true,
				// 		onPostRpc: function(){
				// 			new BldBlimp(this);
				// 		}
				// 	});
				// }


				if (this._bulb_ppsqft && data["ppsqft"] != null) {
					this._bulb_ppsqft.set('html', '$' + Core.add_commas(data["ppsqft"]) + ' /ft<sup>2</sup>');
				} else {
					if (this._bulb_ppsqft) {
						this._bulb_ppsqft.setStyle('display', 'none');
					}
				}

				this._bulb_details.set('text', data.beds_baths);
				this.add_save_support(data);
			}

			var v_pos = _el.getStyle('height').toInt() + this._bulb.getElement('.pointer').getStyle('height').toInt() + this._element.getComputedSize().computedBottom + 1 /*border*/
			,
			    h_pos = _el.getCoordinates().left - this._element.getCoordinates().left - this._bulb.getStyle('width').toInt() / 2 - this._bulb.getStyle('padding-left').toInt() + _el.getCoordinates().width / 2;

			this._bulb.setStyles({
				'bottom': v_pos,
				'left': h_pos > 400 ? h_pos - 160 : h_pos + 160
			});
			if (h_pos > 400) {
				this._bulb.addClass('right-bulb');
			} else {
				this._bulb.removeClass('right-bulb');
			}

			this._bulb.show();
		}
	},

	add_listing_tile: function add_listing_tile(data) {
		// for listings
		if (!this.options.isBuilding) {
			if (this.listingTile) {
				// dont do anything if the user mouseover to the last active listing again
				if (this.listingTile.hasClass('_' + data.mask_id)) {
					return;
				}

				// remove the current save button
				this.listingTile.dispose();
			}

			if (data.listingTile) {
				data.listingTile.inject(this._bulb);
			} else {
				data.contact = '';
				data.listingTile = new Element('<cr-listing-tile', {
					'class': 'cr-listing-tile' + ' _' + data.mask_id,
					'data-rpc': data.url_v2,
					'data-open-blimp-on-click': true,
					'data-missing-image': this.options.missingImage,
					'data-rpc-save-to-profile': this.options.rpcSaveToProfile,
					'html': '<div class="hidden none obj-wrapper">' + JSONMOO.encode(data) + '</div>'
				}).inject(this._bulb);

				Core.compile_html(data.listingTile);
			}

			this.listingTile = data.listingTile;
		}
	},

	add_save_support: function add_save_support(data) {
		if (this.currentSaveButton) {
			var id = this.options.isBuilding ? data.building_id : data.mask_id;
			// dont do anything if the user mouseover to the last active listing again
			if (this.currentSaveButton.hasClass('_' + id)) {
				return;
			}
			// remove the current save button
			this.currentSaveButton.dispose();
		}

		this.currentSaveButton = data.crSaveToProfile;
	},

	bulb_hide: function bulb_hide() {
		if (this._save_tooltip) {
			this._save_tooltip.hide();
		}
		this._bulb.hide();
	},

	add_scrolling: function add_scrolling() {
		this._arr_prev = new Element('.arr_prev');
		this._arr_next = new Element('.arr_next');

		this._columns = this._scroller.getElements('.column');
		this.current_col = 0;

		this._arr_prev.inject(this._chart);
		this._arr_next.inject(this._chart);

		this.animate = new Fx.Scroll(this._scroller, {
			link: 'cancel',
			duration: 1000,
			transition: Fx.Transitions.Quad.easeOut,
			onStart: function () {
				this.hide_locked_item();
			}.bind(this)
		});

		if (this._init_scroll) {
			this._columns.each(function (_el, i) {
				if (_el === this._init_scroll) {
					var half = Math.ceil(this.options.disp_col / 2);

					if (i < half) {
						this.current_col = 0;
						this._arr_prev.addClass('inactive');
					} else if (this._columns.length - i <= half) {
						this.current_col = this._columns.length - this.options.disp_col;
						this._arr_next.addClass('inactive');
					} else {
						this.current_col = i - half + 1;
					}
				}
			}.bind(this));
		} else {
			this._arr_prev.addClass('inactive');
			this.current_col = 0;
		}

		(function () {
			this.animate.toElement(this._columns[this.current_col]).chain(function () {
				this._arr_prev.addEvent('click', this.scroll_prev.bind(this));
				this._arr_next.addEvent('click', this.scroll_next.bind(this));
			}.bind(this));
			this.animate.setOptions({ duration: this.options.scroll_speed });
		}).bind(this).delay(2000);

		this.last = this._columns.length - this.options.disp_col;

		if (this.options.hscroll == true) {
			this.add_hscroll();
		}
	},

	animate_prices: function animate_prices() {
		if (!this.current_col) this.current_col = 0;

		var last_visible = Math.min(this.current_col + this.options.disp_col - 1, this._items.length - 1);
		var speed = 2000;

		this._items.each(function (_el, i) {
			var height = _el.getAttribute('data-height');

			if (i >= this.current_col && i <= last_visible) {
				var sc = speed * _el.getAttribute('data-price').toInt() / this.max_value,
				    //speed coefficient
				delay = (i >= this.current_col ? i - this.current_col : 0) * 100 + 100;

				(function () {
					var tween = new Fx.Morph(_el, { duration: sc, transition: Fx.Transitions.Bounce.easeOut });
					tween.start({ 'height': [0, height] });
				}).delay(delay);
			} else {
				(function () {
					_el.setStyle('height', height.toInt());
				}).delay(500);
			}
		}.bind(this));

		(function () {
			this.bubble_is_ready = true;

			if (this._indicator && this._indicator.hasClass('visible')) {
				this._indicator.fade('in');
			}
		}).bind(this).delay(speed);
	},

	scroll_prev: function scroll_prev() {
		var prev = this.current_col - this.options.scroll_at_a_time;

		if (prev > 0) {
			this.animate.toElement(this._columns[prev]);
			this.current_col -= this.options.scroll_at_a_time;
		} else {
			this.animate.toElement(this._columns[0]);
			this._arr_prev.addClass('inactive');
			this._ar_l.addClass('inactive');
			this.current_col = 0;
		}

		if (this._dragger) {
			var left = this.dragger_max_left / (this._items.length - this.options.disp_col) * this.current_col;
			this.dragger_fx.start({ 'left': left });
		}

		this._arr_next.removeClass('inactive');
		if (this._ar_r) {
			this._ar_r.removeClass('inactive');
		}
	},

	scroll_next: function scroll_next() {
		var next = this.current_col + this.options.scroll_at_a_time;

		if (next < this.last) {
			this.animate.toElement(this._columns[next]);
			this.current_col += this.options.scroll_at_a_time;
		} else {
			this.animate.toElement(this._columns[this.last]);
			this._arr_next.addClass('inactive');
			this._ar_r.addClass('inactive');
			this.current_col = this.last;
		}

		if (this._dragger) {
			var left = this.dragger_max_left / (this._items.length - this.options.disp_col) * this.current_col;
			this.dragger_fx.start({ 'left': left });
		}

		this._arr_prev.removeClass('inactive');
		if (this._ar_l) {
			this._ar_l.removeClass('inactive');
		}
	},

	add_functionalities: function add_functionalities() {
		var self = this;
		this._element.addEvents({
			'mouseenter': function mouseenter() {
				// CITY-5606: phones / tablets — a tap's synthetic mouseover showed the scroll
				// arrows under the finger and the click landed on one (swipe the chart instead)
				if (Core.prefer_pages_over_popups && Core.prefer_pages_over_popups()) return;
				self._element.addClass('_hover');
			},
			'mouseleave': function mouseleave() {
				self._element.removeClass('_hover');
				self.hide_locked_item();
			}
		});
	},

	hide_locked_item: function hide_locked_item() {
		if (this.locked_item) {
			this.bulb_hide();
			this.locked_item.removeClass('_active');
		}
	}
});
'use strict';

var Streetview = new Class({
	Implements: [Options, Events],

	options: {
		cls: "w_streetview",
		container: null,
		zoomControl: true
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			Core.load_google_api(this.build.bind(this));
		}
	},

	build: function build() {
		var _self = this._element,
		    opts = this.options,
		    cls = opts.cls;

		this.mode = 'webgl';
		this.check_webgl();

		var _config = _self.getElement('.' + cls + '_config');
		var _pano = this._pano = _self.getElement('.' + cls + '_pano');

		if (_pano && _config) {
			var config = this.config = JSONMOO.decode(_config.get('text').toString().trim(), false);
			config.mode = this.mode;

			if (!config.position && config.lat && config.lng) {
				config.position = new google.maps.LatLng(config.lat, config.lng);
			}

			var default_config = {
				position: new google.maps.LatLng(40.7642676, -73.9741554),
				addressControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				zoomControl: opts.zoomControl
			};

			var final_config = Object.merge(default_config, config);
			var service = this.service = new google.maps.StreetViewService();

			if (final_config.pov && Object.keys(final_config.pov).length) {
				this.init_pano(final_config);
			} else {
				var panoRequest = {
					location: final_config.position,
					preference: google.maps.StreetViewPreference.NEAREST,
					radius: final_config.radius || 50,
					source: google.maps.StreetViewSource.OUTDOOR
				};
				service.getPanorama(panoRequest, function (pano_data, status) {
					if (status == google.maps.StreetViewStatus.OK) {
						var angle = this.compute_angle(final_config.position, pano_data.location.latLng);

						final_config.pov = {
							'heading': angle,
							'pitch': 0,
							'zoom': 1,
							'pano_data': pano_data
						};
					} else {
						final_config.pov = null;
					}
					this.init_pano(final_config);
				}.bind(this));
			}
		}
	},

	check_webgl: function check_webgl() {
		var canvas = new Element('canvas'),
		    contextNames = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
		    gl = null;

		contextNames.each(function (e, i) {
			if (!gl) {
				try {
					gl = canvas.getContext(contextNames[i]);
				} catch (e) {}
			}
		});

		canvas = null;

		if (gl === null) this.mode = 'html4';
	},

	init_pano: function init_pano(config) {
		if (config.pov.pano_data.location.pano) {
			config.pano = config.pov.pano_data.location.pano;
		}
		var pano = this.pano = new google.maps.StreetViewPanorama(this._pano, Object.merge(config, { visible: true }));

		var marker_config = {
			'position': config.position,
			'clickable': false,
			'map': pano
		};

		if (config.marker) {
			marker_config = Object.merge(marker_config, config.marker);
		}

		this.base_marker = new google.maps.Marker(marker_config);
	},

	compute_angle: function compute_angle(end, start) {
		var DEGREE_PER_RADIAN = 57.2957795;
		var RADIAN_PER_DEGREE = 0.017453;
		var dlat = end.lat() - start.lat();
		var dlng = end.lng() - start.lng();
		var angle = Math.atan2(dlng * Math.cos(end.lat() * RADIAN_PER_DEGREE), dlat) * DEGREE_PER_RADIAN;

		if (angle >= 360) {
			angle -= 360;
		} else if (angle < 0) {
			angle += 360;
		}
		return angle;
	}
});
'use strict';

Page.Agp = new Class({
    Extends: Page,
    build: function build() {
        this.parent();
        this.agent_stalker_data();
        this.agent_stalker_contact();
        this.add_stalker_scroll();
        this.initRecentSalesSlider();
        this.add_agent_sales_chart();
        this.add_agent_news_slider();
    },

    agent_stalker_data: function agent_stalker_data() {
        var info = document.querySelector('.stalker_info');
        var stalker = document.querySelector('.persist_nav.building');
        if (!info || !stalker) return;

        var nameInput = info.querySelector('input[name="agent_name"]');
        var firmInput = info.querySelector('input[name="agent_firm"]');
        var imgInput = info.querySelector('input[name="agent_img"]');

        var name = nameInput ? nameInput.value : '';
        var firm = firmInput ? firmInput.value : '';
        var imgSrc = imgInput ? imgInput.value : '';

        var title = stalker.querySelector('.title');
        var bldgType = stalker.querySelector('.bldg-type');
        if (title) title.textContent = name;
        if (bldgType) bldgType.textContent = firm;

        if (imgSrc) {
            var bldg = stalker.getElement('.bldg');
            var imgEl = stalker.getElement('.building_image img');
            if (bldg && imgEl) {
                bldg.addClass('img');
                var handleError = function handleError() {
                    imgEl.removeEvent('error', handleError);
                    imgEl.set('src', Res_i + '/p/agp/default_user.svg');
                };
                imgEl.set('src', imgSrc);
                imgEl.addEvent('error', handleError);
            }
        }
    },

    agent_stalker_contact: function agent_stalker_contact() {
        var _contactButton = document.querySelector('.stalker_info .send-a-message');
        this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .links-icons');
        if (this._stalker_alert_link && _contactButton) {
            var clonedAlertButton = _contactButton.cloneNode(true);
            this._stalker_alert_link.appendChild(clonedAlertButton);
        }
    },

    add_stalker_scroll: function add_stalker_scroll() {

        var navContainer = document.querySelector('.persist_nav_container');
        var navItems = navContainer.querySelectorAll('.building_nav ul li');

        function handleScroll() {
            var offset = 150;
            var currentSectionClass = null;

            // Dynamically find all elements matching classes in `data-target` attributes
            var scrollableElements = Array.from(document.querySelectorAll('*')).filter(function (el) {
                return Array.from(el.classList).some(function (cls) {
                    return Array.from(navItems).some(function (item) {
                        return item.getAttribute('data-target') === cls;
                    });
                });
            });

            scrollableElements.forEach(function (element) {
                var elementTop = element.getBoundingClientRect().top + window.scrollY;
                var elementHeight = element.offsetHeight;

                // Check if the element is in the viewport
                if (window.scrollY >= elementTop - offset && window.scrollY < elementTop + elementHeight - offset) {
                    currentSectionClass = Array.from(element.classList).find(function (cls) {
                        return Array.from(navItems).some(function (item) {
                            return item.getAttribute('data-target') === cls;
                        });
                    });
                }
            });

            // Update active navigation item
            navItems.forEach(function (item) {
                item.classList.remove('active');
                if (item.getAttribute('data-target') === currentSectionClass) {
                    item.classList.add('active');
                }
            });
        }

        navItems.forEach(function (item) {
            item.addEventListener('click', function () {
                var targetId = this.getAttribute('data-target');
                console.log('targetId', targetId);
                var targetElement = document.querySelector('.' + targetId);
                if (targetElement) {
                    var offset = 200;
                    var elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                    var offsetPosition = elementPosition - offset;

                    // setTimeout(() => {
                    // 	const newUrl = window.location.href.split('#')[0] + `#${targetId}`;
                    // 	window.history.replaceState(null, null, newUrl);
                    // }, 100);

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });

        setTimeout(function () {
            navItems.forEach(function (item) {
                var targetId = item.getAttribute('data-target');
                var targetElement = document.querySelector('.page_content_wrapper .' + targetId);
                if (!targetElement || targetElement.offsetParent === null) {
                    item.remove();
                    return;
                }
            });
        }, 2500);

        window.addEventListener('scroll', handleScroll);

        // Initial call to handleScroll to set the correct active class on page load
        handleScroll();
    },

    add_agent_sales_chart: function add_agent_sales_chart() {
        var _summary_chart = document.getElement('#agent_sales_summary');
        if (_summary_chart) {
            window.agentSalesChart = new AgentSalesSummaryChart(_summary_chart);
        }
    },

    initRecentSalesSlider: function initRecentSalesSlider() {
        var disableButtons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var _recent_sales_wrapper = document.querySelector('.recent-sales-wrapper');
        if (!_recent_sales_wrapper) return;

        var salesList = _recent_sales_wrapper.querySelector('.recent-sales');
        var prevButton = _recent_sales_wrapper.querySelector('#prev-sold');
        var nextButton = _recent_sales_wrapper.querySelector('#next-sold');
        var salesItems = salesList.querySelectorAll('.recent-sale');

        if (salesItems.length <= 3) {
            prevButton.style.display = 'none';
            nextButton.style.display = 'none';
            return;
        }

        var currentIndex = 0;
        var itemWidth,
            visibleItems,
            slidingStep,
            totalItems = salesItems.length,
            maxIndex;

        function calculateValues() {
            itemWidth = salesItems[0].offsetWidth + 20; // Include gap
            visibleItems = Math.floor(_recent_sales_wrapper.offsetWidth / itemWidth);
            slidingStep = visibleItems;
            maxIndex = Math.max(totalItems - visibleItems, 0);
            currentIndex = Math.min(currentIndex, maxIndex);
            salesList.style.transform = 'translateX(' + -currentIndex * itemWidth + 'px)';
            updateButtons();
        }

        function updateButtons() {
            if (disableButtons) {
                prevButton.classList.add('inactive');
                nextButton.classList.add('inactive');
            } else {
                prevButton.classList.toggle('inactive', currentIndex === 0);
                nextButton.classList.toggle('inactive', currentIndex >= maxIndex);
            }
        }

        prevButton.addEventListener('click', function () {
            if (currentIndex > 0) {
                currentIndex = Math.max(currentIndex - slidingStep, 0);
                salesList.style.transform = 'translateX(' + -currentIndex * itemWidth + 'px)';
                updateButtons();
            }
        });

        nextButton.addEventListener('click', function () {
            if (currentIndex < maxIndex) {
                currentIndex = Math.min(currentIndex + slidingStep, maxIndex);
                salesList.style.transform = 'translateX(' + -currentIndex * itemWidth + 'px)';
                updateButtons();
            }
        });

        window.addEventListener('resize', calculateValues);

        prevButton.style.display = 'block';
        nextButton.style.display = 'block';
        calculateValues(); // Initial calculation
    },

    add_agent_news_slider: function add_agent_news_slider() {
        var _editorial_coverage = document.getElementById('agent_news');

        if (_editorial_coverage) {
            var articlesList = _editorial_coverage.querySelector('.articles-list');

            if (articlesList && articlesList.children.length > 6) {
                this.initAgentNewsSlider();
            }
        }
    },

    initAgentNewsSlider: function initAgentNewsSlider() {
        var disableButtons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var _editorial_coverage = document.getElementById('agent_news');
        var articlesList = _editorial_coverage.querySelector('.articles-list');
        var prevButton = _editorial_coverage.querySelector('#prev-article');
        var nextButton = _editorial_coverage.querySelector('#next-article');
        var currentIndex = 0;
        var itemWidth = articlesList.querySelector('.article-item').offsetWidth + parseInt(getComputedStyle(articlesList).gap);
        var visibleItems = 3;
        var totalItems = articlesList.children.length;
        var slidingStep = 3; // Number of items to move per step

        if (totalItems > visibleItems) {
            prevButton.style.display = 'block';
            nextButton.style.display = 'block';
        }

        var maxIndex = Math.max(totalItems - visibleItems, 0);

        function updateButtons() {
            if (disableButtons) {
                prevButton.classList.add('inactive');
                nextButton.classList.add('inactive');
            } else {
                prevButton.classList.toggle('inactive', currentIndex === 0);
                nextButton.classList.toggle('inactive', currentIndex >= maxIndex);
            }
        }

        prevButton.addEventListener('click', function () {
            if (currentIndex > 0) {
                currentIndex = Math.max(currentIndex - slidingStep, 0);
                articlesList.style.transform = 'translateX(' + -currentIndex * itemWidth + 'px)';
                updateButtons();
            }
        });

        nextButton.addEventListener('click', function () {
            if (currentIndex < maxIndex) {
                currentIndex = Math.min(currentIndex + slidingStep, maxIndex);
                articlesList.style.transform = 'translateX(' + -currentIndex * itemWidth + 'px)';
                updateButtons();
            }
        });

        updateButtons();
    }

});
//# sourceMappingURL=agp.js.map
